import PatientSearch from "../global/PatientSearch";

function PatientSelectionPopup({ oktaAuth }: { oktaAuth: any }) {
  return <PatientSearch mode="datalist" oktaAuth={oktaAuth} closeInput={() => { }} />;
}

export default PatientSelectionPopup;
